import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { modulemedia } from 'src/app/models/module/moduledetails';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';
import Player from 'video.js/dist/types/player';

declare var $: any;
//import { Hls } from '../../../assets/js/hls';
//declare const Hls: any;

@Component({
  selector: 'app-media',
  templateUrl: './media.component.html',
  styleUrls: ['./media.component.css']
})
export class ModuleMediaComponent implements OnInit, OnDestroy, AfterViewInit {

  media: modulemedia = new modulemedia();
  moduleid: number = 0;
  uploadid: string = '';
  legacy: boolean = false;
  classid: number = 0;//for legacy stuff
  legacysno: number = 0;
  @ViewChild('video') video: ElementRef;
  @ViewChild('audio') audio: ElementRef;
  @ViewChild('mediacontainer') mediacontainer: ElementRef;
  player: Player = null;
  config = {
    controls: true,
    autoplay: false,
    fluid: false,
    loop: false,
    sources: [],
    responsive: true,
    playbackRates: [0.5, 1, 1.5, 2],
    controlBar: {
        volumePanel: {inline: false},
        pictureInPictureToggle: false,
        fullscreenToggle: true,
        remainingTimeDisplay:{
          displayNegative: false
        }
    },
    html5:{
      vhs:{
        limitRenditionByPlayerDimensions: false,
        useDevicePixelRatio: true
      }
    }
    // width: 700,
    // height: 500,
    // aspectRatio: "1:1",
    // liveui: true,
    // children: {
    // bigPlayButton: true,
    // controlBar: {
    //   volumePanel: {
    //     inline: false
    //   },
    //   ProgressControl: {
    //     SeekBar: {
    //       PlayProgressBar: true
    //     }
    //   }
    //   // }
    // },
    // playbackRates: [0.5, 1, 1.5, 2],
  };
  constructor(private activatedroute: ActivatedRoute, private modulemanager: ModulemanagementService) { }
  async ngAfterViewInit() {
    //debugger;
    if(!this.legacy){
        this.media = await this.modulemanager.getSingleMedia(this.moduleid, this.uploadid).toPromise();
    }else{
        this.media = await this.modulemanager.getSingleLegacyMedia(this.classid, this.legacysno).toPromise();
        //debugger;
    }

    //debugger;
    if(this.media.type.startsWith('video')){
        // Loaded on demand — video.js and its HLS quality-selector plugin are only
        // needed on this page, not on every route that happens to eagerly import media.component.
        const videojs = (await import('video.js')).default;
        await import('videojs-hls-quality-selector');

        this.config.sources = [];
        const video: any = this.video.nativeElement;
        if (this.media.hlsmediaurl) {
            this.config.sources.push({src: this.media.hlsmediaurl, type: 'application/vnd.apple.mpegurl'});
        }
        else{
            this.config.sources.push({src: this.media.mediaurl, type: this.media.type});
        }

        this.player = videojs(this.video.nativeElement, this.config, () => {
            const container = this.mediacontainer.nativeElement.querySelector('.video-js');
            
            if(container){
                $(container).css('display', '');
            }
            // console.log('player ready! id:', el);
      
            // // print version information at startup
            // var msg = 'Using video.js ' + videojs.VERSION +
            //   ' with videojs-record ' + videojs.getPluginVersion('record') +
            //   ' and recordrtc ' + RecordRTC.version;
            // videojs.log(msg);
            //this.loadHlsVideo(this.media.hlsmediaurl, this.media.mediaurl);
        });
        
        if (this.media.hlsmediaurl){
          const player: any = this.player;
          player.hlsQualitySelector({
            displayCurrentQuality: true,
          });
        }
    }
    else{
        this.audio.nativeElement.src = this.media.mediaurl;
    }

    if(this.media && this.media.type && this.media.type.startsWith('audio')){
        $(self.frameElement).css('height', '60px');//.style.height = '60px';
    }
  }

  ngOnInit() {
    //debugger;
    document.body.style.overflow = 'hidden';
    this.moduleid = parseInt(this.activatedroute.snapshot.queryParams.moduleid);
    this.uploadid = this.activatedroute.snapshot.queryParams.uploadid;
    this.legacy = this.activatedroute.snapshot.data.legacy;
    this.classid = parseInt(this.activatedroute.snapshot.params.classid);
    this.legacysno = parseInt(this.activatedroute.snapshot.queryParams.sno);
  }

  ngOnDestroy() {
    // destroy player
    if (this.player) {
      this.player.dispose();
    }
  }

  loadHlsVideo(hlsurl, nonhlsurl) {
    const video = this.video.nativeElement;
    //const audio = this.audio.nativeElement;
    if (video) {
      //debugger;
        // if (Hls.isSupported()) {
        //     let m3u8url = hlsurl;

        //     if (m3u8url.endsWith('.m3u8')) {
        //         let hls = new Hls();
        //         let resolutiondiv;
        //         console.log('hls url: ' + m3u8url);
        //         //debugger;
        //         hls.loadSource(m3u8url);
        //         hls.attachMedia(video);
        //         hls.on(Hls.Events.MANIFEST_PARSED, function () {
        //             //video.play();
        //             //debugger;
        //             let videoparent = video.parentElement;

        //             let qualitycontainer = document.createElement('div');
        //             qualitycontainer.setAttribute('class', 'video_quality');
        //             let dropdown = document.createElement('div');
        //             dropdown.setAttribute('class', 'btn-group');
        //             let r = Math.random().toString(36).substring(7);
        //             //console.log("random", r);

        //             let dropdownbuttonid = `dropdown_${r}`;

        //             let qualitybutton = document.createElement('button');
        //             qualitybutton.setAttribute('id', dropdownbuttonid);
        //             qualitybutton.setAttribute('class', 'fas fa-cog videoqualitybutton dropdown');
        //             qualitybutton.setAttribute('type', 'button');
        //             qualitybutton.setAttribute('data-toggle', 'dropdown');
        //             qualitybutton.setAttribute('aria-haspopup', 'true');
        //             qualitybutton.setAttribute('aria-expanded', 'false');

        //             dropdown.appendChild(qualitybutton);

        //             let menu = document.createElement('ul');
        //             menu.setAttribute('class', 'dropdown-menu hls_quality_dropdown_menu');
        //             menu.setAttribute('role', 'menu');
        //             menu.setAttribute('aria-labelledby', dropdownbuttonid);

        //             //debugger;
        //             //hls.levelController.levels[0].width
        //             for (let i = hls.levelController.levels.length - 1; i >= -1; i--) {
        //                 let li = document.createElement('li');
                        
        //                 let a = document.createElement('a');
        //                 a.setAttribute('class', 'dropdown-item hls_quality_option');
        //                 let level = hls.levelController.levels[i];
        //                 if (i >= 0) {
        //                     a.innerText = `${level.width} x ${level.height}`;
        //                 }
        //                 else {
        //                     a.innerText = 'Auto';
        //                 }
        //                 a.setAttribute('href', 'javascript:void(0)');
        //                 a.onclick = function () {
        //                     //hls.levelController.manualLevel = i;
        //                     hls.currentLevel = i;
        //                     //set url to level.url
        //                     //let videotime = video.currentTime;
        //                     ////debugger;
        //                     ////hls.loadSource(level.url[0]);
        //                     //hls.destroy();
        //                     //hls = new Hls();
        //                     ////hls.loadSource(level.url[0]);
        //                     //debugger;
        //                     //hls.attachMedia(video);
        //                     //hls.on(Hls.Events.MANIFEST_PARSED, () => {
        //                     //    //video.currentTime = videotime;
        //                     //    //video.play();
        //                     //});
                            
        //                 };
        //                 li.appendChild(a);
        //                 menu.appendChild(li);
        //             }

        //             resolutiondiv = document.createElement('div');
        //             resolutiondiv.setAttribute('class', 'hls_quality_div');

                    
        //             //resolutiondiv.innerText = 

        //             dropdown.appendChild(menu);

        //             qualitycontainer.appendChild(dropdown);
        //             qualitycontainer.appendChild(resolutiondiv);
        //             videoparent.appendChild(qualitycontainer);
        //         });
        //         var displayResolution = function (levelno) {
        //             let level = hls.levelController.levels[levelno];
        //             let resolution = `${level.width} x ${level.height}`;
        //             resolutiondiv.innerText = resolution;
        //         }
        //         hls.on(Hls.Events.LEVEL_SWITCHED, function (event, args) {
        //             //debugger;
        //             let levelno = args.level;
        //             displayResolution(levelno);
        //         });
        //         hls.on(Hls.Events.LEVEL_UPDATED, function (event, args) {
        //             //debugger;
        //             let levelno = args.level;
        //             displayResolution(levelno);
        //         });
        //         video.addEventListener('canplay', function () {
        //             if (!this.hasAttribute('userclickedplay') && !this.hasAttribute('canplayfired')) {
        //                 hls.stopLoad();
        //                 this.setAttribute('stoppedloading', '');// = true;
        //             }
        //             this.setAttribute('canplayfired', '');// = true;
        //         });
        //         video.addEventListener('play', function () {
        //             this.setAttribute('userclickedplay', '');// = true;
        //             if (this.hasAttribute('stoppedloading')) {
        //                 hls.startLoad();
        //                 this.removeAttribute('stoppedloading');// = false;
        //             }
        //         });
                
        //         //<div class="video_quality"><button class="fa fa-gear videoqualitybutton"></button></div>
        //     }
        //     else {
        //         video.src = m3u8url;
        //     }
        // }
        //else 
        // if (video.canPlayType('application/vnd.apple.mpegurl')) {
        //     video.src = hlsurl;
        // }
        // else {
        //     video.src = nonhlsurl;
        // }
    }
}

}
